export default "__VITE_ASSET__FM2LoqnF__"